import { render, staticRenderFns } from "./PageHero.vue?vue&type=template&id=7f0e70d3&scoped=true"
import script from "./PageHero.vue?vue&type=script&lang=ts"
export * from "./PageHero.vue?vue&type=script&lang=ts"
import style0 from "./PageHero.vue?vue&type=style&index=0&id=7f0e70d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0e70d3",
  null
  
)

export default component.exports